import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarketingPageStateService {
  private readonly isMarketingPageVisibleSubject = new BehaviorSubject<boolean>(false);
  private readonly isSeoLandingPageVisibleSubject = new BehaviorSubject<boolean>(false);
  private readonly isPromotionalHomeSubject = new BehaviorSubject<boolean>(false);
  private readonly isMarketingProPageSubject = new BehaviorSubject<boolean>(false);
  private readonly isWhiteLabelCoverPageVisibleSubject = new BehaviorSubject<boolean>(false);

  readonly isMarketingPageVisible$: Observable<boolean> = this.isMarketingPageVisibleSubject.asObservable();
  readonly isSeoLandingPageVisible$: Observable<boolean> = this.isSeoLandingPageVisibleSubject.asObservable();
  readonly isPromotionalHome$: Observable<boolean> = this.isPromotionalHomeSubject.asObservable();
  readonly isMarketingProPage$: Observable<boolean> = this.isMarketingProPageSubject.asObservable();
  readonly isWhiteLabelCoverPageVisible$: Observable<boolean> =
    this.isWhiteLabelCoverPageVisibleSubject.asObservable();

  get isMarketingPageVisible(): boolean {
    return this.isMarketingPageVisibleSubject.getValue();
  }

  get isPromotionalHome(): boolean {
    return this.isPromotionalHomeSubject.getValue();
  }

  setMarketingPageVisible(visible: boolean): void {
    this.isMarketingPageVisibleSubject.next(visible);
  }

  setPromotionalHome(visible: boolean): void {
    this.isPromotionalHomeSubject.next(visible);
  }

  setSeoLandingPageVisible(visible: boolean): void {
    this.isSeoLandingPageVisibleSubject.next(visible);
  }

  setMarketingProPage(visible: boolean): void {
    this.isMarketingProPageSubject.next(visible);
  }

  setWhiteLabelCoverPageVisible(visible: boolean): void {
    this.isWhiteLabelCoverPageVisibleSubject.next(visible);
  }
}
